
var arr = 
[
  {
    title: 'الصفحة الرئيسية',
    route: 'home',
    icon: 'HomeIcon',
    per: "home"
  },
  {
    title: 'المستخدمين',
    route: 'users',
    icon: 'UsersIcon',
    per: "home"
  },
  {
    title: 'الطلبات',
    route: 'orders',
    icon: 'ShoppingCartIcon',
    per: "home"
  },
  {
    title: 'مواعيد الاتصالات',
    route: 'calls',
    icon: 'PhoneIcon'
  },
  {
    title: 'المشاكل',
    route: 'feedback2',
    icon: 'ListIcon'
  },
  {
    title: 'نقل التقارير من القديم',
    route: 'move-from-old',
    icon: 'DatabaseIcon',
    per: "move-from-old"
  },
  {
    title: 'الاراء والاقتراحات',
    route: 'feedback1',
    icon: 'EditIcon'
  },
  {
    title: 'تدخل برمجي',
    route: 'ups',
    icon: 'CodeIcon',
    per: "freedays"
  },
  {
    title: 'الاجازات والعطلات',
    route: 'freedays',
    icon: 'CalendarIcon',
    per: "freedays"
  },
  {
    title: 'الأخبار / التطويرات',
    route: 'posts',
    icon: 'BellIcon',
    per: "home"
  },
  {
    title: 'الخدمات',
    route: 'services',
    icon: 'ShoppingCartIcon',
    per: "home"
  },
  {
    title: 'الاعدادات',
    route: 'settings',
    icon: 'SettingsIcon',
    per: "home"
  },
  {
    title: 'ملف الإنجاز',
    icon: 'FileIcon',
    tagVariant: 'light-warning',
    children: [
        {
            title: 'المستخدمين',
            route: 'enjazfile/users',
        },
        {
            title: 'الطلبات',
            route: 'enjazfile/orders',
        },
    ],
  },
  {
    title: 'الشركاء',
    icon: 'UserCheckIcon',
    tagVariant: 'light-warning',
    children: [
        {
            title: 'استعراض الشركاء',
            route: 'resellers',
        },
        {
            title: 'الزيارات',
            route: 'visits',
        },
        {
            title: 'المواعيد',
            route: 'calendar',
        },
        {
            title: 'المهام',
            route: 'todo',
        },
    ],
  },
  {
    title: 'المساعد الذكي',
    icon: 'MessageSquareIcon',
    per: "home",
    children: [
        {
            title: 'المحادثات',
            route: 'ai-chats',
        },
        {
            title: 'إعدادات المساعد',
            route: 'ai-settings',
        },
    ],
  },
  {
    title: 'اجهزة البصمة الجميلة',
    route: 'devices',
    icon: 'ServerIcon',
    per: "home"
  },
  {
    title: 'اختصار الروابط',
    icon: 'LinkIcon',
    href: "https://tahdir.net/ShortLink.php",
  },
  {
    title: 'تسجيل الخروج',
    route: 'logout',
    icon: 'LogOutIcon'
  },
]

export default arr
